import React, { memo } from "react"
import styled from "@emotion/styled"

import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

const SubtitleWrap = styled.div`
  position: absolute;
  width: 100%;
  bottom: 24px;
  p {
    text-shadow: 2px 2px rgba(0,0,0,.25);
  }
`

const Subtitle = ({ subtitle }) => {
  return (
    <SubtitleWrap className="px-4 mx-auto">
      <TextElementMen text={subtitle} element="p" className="title--large subtitle text-master-base-default text-center" />
    </SubtitleWrap>
  )
}

export default memo(Subtitle)